import { sendToApi } from 'api/client'

export interface CreditUsage {
  base_credits_available: number
  content_credits_used: number
  video_credits_used: number
  ads_credits_used: number
  visual_styles_credits_used: number
  ai_image_credits_used?: number
  plagiarism_credits_used?: number
  gen_v2_image_credits_used?: number
  gen_v2_video_credits_used?: number
  subscription_id: string | null
  total_credits_available: number
  total_credits_used: number
  credits_remaining: number
  credits_exceeded: boolean
  start_date: string | null // ISO date string (YYYY-MM-DD)
  end_date: string | null // ISO date string (YYYY-MM-DD)
  initial_credits_available: number
  total_additional_credits: number
  usage_costs: {
    content_credits_cost: number
    video_credits_cost: number
    ads_credits_cost: number
    visual_styles_credits_cost: number
    ai_image_credits_cost: number
    plagiarism_credits_cost: number
    still_image_credits_cost: number
    carousel_credits_cost: number
    script_video_credits_cost: number // v2 short form video
    animated_video_credits_cost: number // v2 feed video
    avatar_video_credits_cost: number // v2 AI avatar video
    design_edit_credits_cost: number
    blog_post_credits_cost: number
    newsletter_credits_cost: number
  }
  can_auto_reload: boolean
  credits_expiring_soon: number
  credits_expiring_breakdown?: {
    in_3_days: number
    in_15_days: number
  }
}

export const CreditUsageClient = {
  getCreditUsage: (workspaceId: number) => {
    return sendToApi<{ credit_usage: CreditUsage }>(`/w/${workspaceId}/credit_usage`, {
      method: 'GET',
    })
  },
}
